export default function Deferred() {
  let resolveFn;
  let rejectFn;
  const eventTarget = new EventTarget();

  const promise = new Promise((resolve, reject) => {
    resolveFn = resolve;
    rejectFn = reject;
  });

  const notify = (progress) => {
    const event = new CustomEvent('progress', { detail: progress });
    eventTarget.dispatchEvent(event);
  };

  eventTarget.addEventListener('progress', (event) => {
    resolveFn(event.detail);
  });

  return {
    promise,
    resolve: resolveFn,
    reject: rejectFn,
    notify,
  };
}
